import React from 'react';
import { Building48Filled } from '@fluentui/react-icons';
import { mergeClasses } from '@fluentui/react-components';
import { useSpaceImageFallbackStyles } from './SpaceImageFallback.styles';

export interface SpaceImageFallbackProps {
  className?: string;
}

export const SpaceImageFallback: React.FC<SpaceImageFallbackProps> = ({ className }) => {
  const styles = useSpaceImageFallbackStyles();

  return (
    <div
      className={mergeClasses(styles.root, className)}
      role="img"
      aria-label="Conference room image not available"
    >
      <div className={styles.inner}>
        <Building48Filled className={styles.icon} />
      </div>
    </div>
  );
};
